// extracted by mini-css-extract-plugin
module.exports = {"profileDetailsContainer":"CreatorCard_profileDetailsContainer__8QORX","profileDetails":"CreatorCard_profileDetails___qPEt","avatar":"CreatorCard_avatar__w8yic"};